"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es6.regexp.split");

var _commom = require("../../../api/commom");

var _dictionary = require("../../../utils/dictionary");

var _sessionCache = require("../../../utils/sessionCache");

//
//
//
//
//
//
//
//
//
//
//
//
// 获取同步信息的接口
var apis = {
  subject: _commom.getSubjectList,
  section: _commom.getSectionList,
  edition: _commom.getEditionList,
  grade: _commom.getGradeList,
  volume: _commom.getVolumeList,
  period: _commom.getPeriodList
}; // 缓存同步信息的接口

var cacheKeys = {
  subject: _dictionary.cacheKeysDictionary.TAO_ZHI_CACHE_SUBJECT,
  section: _dictionary.cacheKeysDictionary.TAO_ZHI_CACHE_SECTION,
  edition: _dictionary.cacheKeysDictionary.TAO_ZHI_CACHE_EDITION,
  grade: _dictionary.cacheKeysDictionary.TAO_ZHI_CACHE_GRADE,
  volume: _dictionary.cacheKeysDictionary.TAO_ZHI_CACHE_VOLUME,
  period: _dictionary.cacheKeysDictionary.TAO_ZHI_CACHE_PERIOD
};
var _default = {
  name: 'FormSyncInfo',
  props: {
    value: {
      type: String,
      default: undefined
    },
    type: {
      type: String,
      default: 'subject'
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      options: []
    };
  },
  computed: {
    valueProxy: {
      get: function get() {
        if (this.multiple) {
          return this.value ? this.value.split(',') : [];
        }

        return this.value;
      },
      set: function set(value) {
        if (this.multiple) {
          this.$emit('input', value ? value.join(',') : undefined);
        } else {
          this.$emit('input', value);
        }
      }
    },
    api: function api() {
      return apis[this.type] ? apis[this.type] : apis.subject;
    },
    // 当前获取数据使用的 api
    cacheKey: function cacheKey() {
      return cacheKeys[this.type] ? cacheKeys[this.type] : cacheKeys.subject;
    } // 当前数据的缓存 key

  },
  mounted: function mounted() {
    this.update();
  },
  methods: {
    update: function () {
      var _update = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.cacheKey || !this.api)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return (0, _sessionCache.remember)(this.cacheKey, this.getter);

              case 5:
                this.options = _context.sent;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                message = _context.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function update() {
        return _update.apply(this, arguments);
      }

      return update;
    }(),
    getter: function () {
      var _getter = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$this$api, data, message;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.api();

              case 3:
                _yield$this$api = _context2.sent;
                data = _yield$this$api.data;
                return _context2.abrupt("return", data);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                message = _context2.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });
                return _context2.abrupt("return", undefined);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function getter() {
        return _getter.apply(this, arguments);
      }

      return getter;
    }()
  }
};
exports.default = _default;